const removeBlankSpace = (str: string): string => str.replace(/\s/g, '');

export {
  removeBlankSpace as removeBlankSpaceUtil,
}